import { useState } from "react"
import { usePostInvitation } from "../../hooks/useInvitations"
import { useAccount } from "../../hooks/useAccount"
import { useQueryClient } from "@tanstack/react-query"

type Props = {
  closeModal: () => void
}

export const InvitationModal = ({ closeModal }: Props) => {
  const queryClient = useQueryClient()
  const { account } = useAccount()
  const { mutateAsync, isPending: isPostInvitationPending } =
    usePostInvitation()

  const [inputs, setInputs] = useState({
    email: ""
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e?.target?.name
    const value = e?.target?.value
    setInputs((values) => ({ ...values, [name]: value }))
  }

  const handleSendInvitation = async () => {
    if (!!account?.study_id)
      await mutateAsync({
        invitation_lock: {
          email: inputs.email,
          study_id: account?.study_id
        }
      }).then(() => {
        queryClient.invalidateQueries({ queryKey: ["invitation_locks"] })
        closeModal()
      })
  }

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="h-1/2 w-1/2 my-6 mx-auto">
          <div className="rounded-xl shadow-lg bg-white outline-none focus:outline-none h-full">
            <div className="flex h-[10%] flex-col pl-4">
              <div className="flex items-center justify-between flex-1 w-full py-4 md:pt-6 px-4">
                <div className="flex flex-1">
                  <h3 className="text-cortexx-550 font-semibold">
                    Inviter un patient
                  </h3>
                </div>
                <div className="flex flex-1">
                  <button
                    className="p-1 ml-auto border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={closeModal}
                  >
                    <img
                      src="/images/close-circle.svg"
                      style={{ height: "25px" }}
                      alt="close"
                      loading="lazy"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="flex h-[70%] flex-col py-4 px-4 w-full">
              <div className="flex flex-col items-start justify-start flex-1 w-full py-4 md:pt-6 px-4 gap-4">
                <div className="text-base text-sumo-500">
                  Pour procéder à l'invitation veuillez entrer l'e-mail du
                  patient.
                </div>
                <div className="text-base text-sumo-500">
                  <input
                    className="border-2 border-slate-300 rounded-xl w-96 py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
                    name="email"
                    type="email"
                    placeholder="email"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="flex h-[20%] flex-col py-4 px-4 w-full">
              <div className="flex flex-col items-end justify-end flex-1 w-full p-4">
                {!isPostInvitationPending ? (
                  <button
                    className="flex gap-2 bg-sumo-550 px-6 py-2 rounded-xl justify-center items-center text-sumo-50 font-semibold"
                    onClick={handleSendInvitation}
                  >
                    <div className="flex-row flex items-end justify-end mx-2 my-1">
                      Envoyer
                    </div>
                  </button>
                ) : (
                  <button className="bg-sumo-100 text-sumo-500 font-semibold px-6 py-2 rounded-xl">
                    <div className="flex-row flex items-end justify-end mx-2 my-1">
                      <p>Envoi</p>
                      <div className="ml-2">
                        <img
                          src="/images/fade-stagger-circles.svg"
                          style={{ height: "20px" }}
                          alt="close"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-45 fixed inset-0 z-40 bg-black"></div>
    </>
  )
}
